import { useState, useEffect } from 'react';

export const LYRRA_A11Y_STORAGE_KEY = 'lyrra-a11y-v3';
export const LYRRA_A11Y_UPDATED_EVENT = 'lyrra-a11y-updated';

function readKeyboardNavFromStorage(): boolean {
  try {
    const raw = localStorage.getItem(LYRRA_A11Y_STORAGE_KEY);
    if (!raw) return false;
    const parsed = JSON.parse(raw) as { keyboardNavigation?: boolean };
    return Boolean(parsed.keyboardNavigation);
  } catch {
    return false;
  }
}

/** Suit l’option « navigation clavier » du centre d’accessibilité (localStorage + événement interne). */
export function useKeyboardNavigationSetting(): boolean {
  const [enabled, setEnabled] = useState(readKeyboardNavFromStorage);

  useEffect(() => {
    const sync = () => setEnabled(readKeyboardNavFromStorage());
    window.addEventListener('storage', sync);
    window.addEventListener(LYRRA_A11Y_UPDATED_EVENT, sync);
    return () => {
      window.removeEventListener('storage', sync);
      window.removeEventListener(LYRRA_A11Y_UPDATED_EVENT, sync);
    };
  }, []);

  return enabled;
}

export function isTypingInFormField(target: EventTarget | null): boolean {
  const el = target;
  if (!el || !(el instanceof HTMLElement)) return false;
  if (el.isContentEditable) return true;
  const tag = el.tagName;
  if (tag === 'TEXTAREA' || tag === 'SELECT') return true;
  if (tag === 'INPUT') {
    const type = (el as HTMLInputElement).type?.toLowerCase() ?? 'text';
    if (['button', 'submit', 'reset', 'checkbox', 'radio', 'range', 'file'].includes(type)) return false;
    return true;
  }
  return false;
}
